module.exports = __webpack_public_path__ + "img/corneal-staining-2.e0626a1c.jpg";